import axios from 'axios';

const namespaced = true
import moment from "moment";

const state = {
    messages: [],
    fetchActive: true,
    unreadSystemMessages: 0
}

const actions = {
    async getAll({dispatch}) {
        return await dispatch('database/getItems', {table: 'messages'}, {root: true})
    },
    async fetchFromHttp({dispatch}, id) {
        let posts = (await axios.get('https://mantel-api.mobile.documedias.systems/v2/conferences/' + id + '/news')).data;
        await dispatch('database/upsertItems', {items: posts, table: 'news'}, {root: true});
        return posts;
    },

    async fetchMessages({dispatch, state, rootState}, id) {
        let messages = await dispatch('database/getItems', {table: 'messages'}, {root: true})
        messages = messages.sort((a, b) => {
            return new Date(b.created_at) - new Date(a.created_at);
        });
        state.messages = messages;
    },

    async saveMessage({dispatch,state, commit},data){
        let messages = [data.message];
        let count = data.count;
        if(count){
            commit('setUnreadSystemMessages', (state.unreadSystemMessages +count));
            console.log('saved message', state.unreadSystemMessages)
        }
        await dispatch('database/upsertItems', {items: messages, table: 'messages'}, {root: true});
    },
    async markMultipleAsRead({dispatch}, messages){
        for (let i = 0; i < messages.length;i++){
            messages[i].read = true;
        }
        await dispatch('database/upsertItems', {items: messages, table: 'messages'}, {root: true});
    },


    getNewsNumber() {
        return state.newsNumber;
    }
}
const mutations = {
    addNewsNumber(state, newsNumber) {
        state.newsNumber = newsNumber + state.newsNumber;
    },
    resetNewsNumber(state, newsNumber) {
        state.newsNumber = newsNumber;
    },
    setUnreadSystemMessages(state,counter){
        state.unreadSystemMessages = counter;
    }
}
const getters = {}

export const messages = {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
